import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { NotificationRow } from '@models/notification';
import dayjs from 'dayjs';

import useNotificationClick from './hooks/useNotificationClick';

interface Props {
    notification: NotificationRow
}

function NotificationItem({ notification }:Props) {
    const {
        readAt, title, createdAt, body,
    } = notification;
    const onClick = useNotificationClick(notification);
    return (<Item fullWidth
        isRead={!!readAt}
        onClick={onClick}
        spacing={4} >
        <Row fullWidth
            justify='space-between'
            align='center' >
            <Text size='s'
                color='#464B50' >
                {title}
            </Text>
            <Text size='s'
                color='#464B50' >
                {createdAt ? dayjs(createdAt).format('YYYY.MM.DD. HH:mm') : '-'}
            </Text>
        </Row>
        <ContentText size='s'>{body}</ContentText>
    </Item>);
}

const Item = styled(Column)<{
    isRead: boolean;
}>`
    background-color: var(--color-primary-opacity-20);
    padding: 16px 22px;

    ${({ isRead }) => (isRead ? css`
        background-color: white;
    ` : undefined)}
`;

const ContentText = styled(Text)`
    white-space: pre-wrap;
    word-break: break-word;
`;

export default NotificationItem;
